
import { Vue, Options } from 'vue-class-component';

@Options({
	name: 'InvalidToken',
})
export default class InvalidToken extends Vue {}
